import type { ReactNode } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { DataConfidenceRibbon } from "@/components/DataConfidenceRibbon";
import { SideNav } from "@/components/SideNav";
import { TopBar } from "@/components/TopBar";
import { DrillProvider } from "@/context/DrillContext";
import { ScopeProvider } from "@/context/ScopeContext";
import { AccountsAttentionPage } from "@/pages/AccountsAttentionPage";
import { CommandCenterPage } from "@/pages/CommandCenterPage";
import { CustomerDetailPage } from "@/pages/CustomerDetailPage";
import { CustomersPage } from "@/pages/CustomersPage";
import { DataSourcesPage } from "@/pages/DataSourcesPage";
import { DevicePage } from "@/pages/DevicePage";
import { DistrictsPage } from "@/pages/DistrictsPage";
import { FinancePage } from "@/pages/FinancePage";
import { FleetHealthPage } from "@/pages/FleetHealthPage";
import { GeoPage } from "@/pages/GeoPage";
import { LifecyclePage } from "@/pages/LifecyclePage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { RecipientPage } from "@/pages/RecipientPage";
import { ReconciliationPage } from "@/pages/ReconciliationPage";
import { RmaReturnsPage } from "@/pages/RmaReturnsPage";
import { SupplyChainPage } from "@/pages/SupplyChainPage";
import { TelemetryPage } from "@/pages/TelemetryPage";

// App shell: a fixed brand block + left nav + top bar + a persistent data-confidence ribbon
// wrapping the routed surface. One canonical layout per surface (no persona reshuffle).
export const App = (): ReactNode => (
  <BrowserRouter>
    <ScopeProvider>
      <DrillProvider>
        <div className="app-shell">
          <div className="brand">
            <span className="brand-mark">B</span>
            <span>
              <span className="brand-word">BusRight</span>
              <br />
              <span className="brand-sub">Hardware Hub</span>
            </span>
          </div>
          <TopBar />
          <SideNav />
          <main className="main">
            <DataConfidenceRibbon />
            <Routes>
              <Route path="/" element={<CommandCenterPage />} />
              <Route path="/health" element={<FleetHealthPage />} />
              <Route path="/telemetry" element={<TelemetryPage />} />
              <Route path="/geo" element={<GeoPage />} />
              <Route path="/districts" element={<DistrictsPage />} />
              <Route path="/customers" element={<CustomersPage />} />
              <Route path="/customers/:id" element={<CustomerDetailPage />} />
              <Route path="/supply" element={<SupplyChainPage />} />
              <Route path="/finance" element={<FinancePage />} />
              <Route path="/lifecycle" element={<LifecyclePage />} />
              <Route path="/data-sources" element={<DataSourcesPage />} />
              <Route path="/device/:serial" element={<DevicePage />} />
              <Route path="/recipient/:id" element={<RecipientPage />} />
              <Route path="/rma" element={<RmaReturnsPage />} />
              <Route path="/accounts" element={<AccountsAttentionPage />} />
              <Route path="/reconcile" element={<ReconciliationPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </main>
        </div>
      </DrillProvider>
    </ScopeProvider>
  </BrowserRouter>
);
